import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { AuthShell } from "@/components/brand";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Detect if this is a first-time account setup vs a password reset
  const isSetup = searchParams.get("setup") === "true";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow={isSetup ? "Account Setup" : "Account Recovery"}
      title={submitted ? "Check your email" : isSetup ? "Create your login" : "Forgot password?"}
    >
      {!submitted ? (
        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-mute text-sm">
            {isSetup
              ? "Enter the email address your account was set up with and we'll send you a link to create your password."
              : "Enter your email and we'll send you reset instructions."}
          </p>
          <input type="email"
            placeholder={isSetup ? "Your city email address" : "Email address"}
            value={email} onChange={e => setEmail(e.target.value)} required
            className="input-flat h-11" />
          <button type="submit" disabled={loading}
            className="btn-primary w-full h-11">
            {loading ? "Sending..." : isSetup ? "Send setup link" : "Send reset instructions"}
          </button>
          <p className="text-center">
            <button type="button"
              onClick={() => navigate(isSetup ? "/admin-login" : "/")}
              className="text-xs text-mute hover:text-ink transition-colors">
              {isSetup ? "Back to portal login" : "Back to login"}
            </button>
          </p>
        </form>
      ) : (
        <div className="space-y-4">
          <div className="w-12 h-12 rounded-[10px] flex items-center justify-center bg-mint border border-[#cfe9db]">
            <svg className="w-6 h-6 text-equal-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
          </div>
          <div>
            <p className="text-ink text-sm font-semibold mb-1">
              {isSetup ? "Setup link sent!" : "Instructions sent!"}
            </p>
            <p className="text-mute text-sm leading-relaxed">
              {isSetup
                ? `We've sent a setup link to ${email}. Check your inbox and click the link to create your password.`
                : `If an account exists for ${email}, instructions are on their way.`}
            </p>
          </div>
          <button onClick={() => navigate("/admin-login")}
            className="btn-primary w-full h-11">
            Back to Login
          </button>
        </div>
      )}
    </AuthShell>
  );
}
